import { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Menu, X } from "lucide-react";

const LINKS = [
  { label: "Início", hash: "#inicio", testid: "nav-link-inicio" },
  { label: "História", hash: "#historia", testid: "nav-link-historia" },
  { label: "Liderança", hash: "#lideranca", testid: "nav-link-lideranca" },
  { label: "Horários", hash: "#horarios", testid: "nav-link-horarios" },
  { label: "Galeria", hash: "#galeria", testid: "nav-link-galeria" },
  { label: "Doações", hash: "#doacoes", testid: "nav-link-doacoes" },
  { label: "Contato", hash: "#contato", testid: "nav-link-contato" },
];

export const scrollToHash = (hash) => {
  document.querySelector(hash)?.scrollIntoView({ behavior: "smooth", block: "start" });
};

export default function Nav() {
  const [open, setOpen] = useState(false);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
      className="fixed top-0 inset-x-0 z-50 bg-obsidian/80 backdrop-blur-xl border-b border-white/10"
      data-testid="main-nav"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
        <button
          data-testid="nav-logo"
          onClick={() => scrollToHash("#inicio")}
          className="flex items-center gap-3 group"
        >
          <img
            src="/assets/logo.jpeg"
            alt="Projeto Bonsai BJJ"
            className="w-9 h-9 rounded-full object-cover ring-1 ring-gold/60 transition-transform duration-300 group-hover:scale-110"
          />
          <span className="font-display font-bold tracking-tight text-sm sm:text-base">
            PROJETO <span className="text-gold">BONSAI</span> BJJ
          </span>
        </button>

        <nav className="hidden lg:flex items-center gap-7">
          {LINKS.map((l) => (
            <button
              key={l.hash}
              data-testid={l.testid}
              onClick={() => scrollToHash(l.hash)}
              className="font-mono text-xs tracking-widest text-zinc-400 hover:text-gold transition-colors duration-200"
            >
              {l.label.toUpperCase()}
            </button>
          ))}
          <Link
            to="/login"
            data-testid="nav-link-login"
            className="font-mono text-xs tracking-widest text-zinc-400 hover:text-gold transition-colors duration-200"
          >
            LOGIN
          </Link>
          <button
            data-testid="nav-cta-apoie"
            onClick={() => scrollToHash("#doacoes")}
            className="font-display font-semibold text-sm bg-gold text-obsidian px-5 py-2 rounded-full hover:bg-gold-amber hover:shadow-[0_0_24px_rgba(212,175,55,0.4)] transition-all duration-300"
          >
            Apoie o Projeto
          </button>
        </nav>

        <button
          data-testid="nav-mobile-toggle"
          className="lg:hidden text-zinc-300 hover:text-gold transition-colors"
          onClick={() => setOpen(!open)}
          aria-label="Menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-white/10 bg-obsidian/95 backdrop-blur-xl px-5 py-4 flex flex-col gap-4" data-testid="nav-mobile-menu">
          {LINKS.map((l) => (
            <button
              key={l.hash}
              data-testid={`${l.testid}-mobile`}
              onClick={() => { setOpen(false); scrollToHash(l.hash); }}
              className="text-left font-mono text-sm tracking-widest text-zinc-300 hover:text-gold transition-colors"
            >
              {l.label.toUpperCase()}
            </button>
          ))}
          <Link to="/login" data-testid="nav-link-login-mobile" className="font-mono text-sm tracking-widest text-zinc-300 hover:text-gold transition-colors">
            LOGIN
          </Link>
        </div>
      )}
    </motion.header>
  );
}
